import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const configurationLocaleModule: LocaleModule = {
  name: "configuration",
  messages: { en: en, it: it },
};
